import React from 'react'
import useTranslations from 'i18n/useTranslations';
const BottomCustomer = ({profile = '',coupon=''}) => {
    const { t } = useTranslations();
    return (
        <section id="pBottomMenu">
            <div className="bBottomMenu">
                <nav>
                    {/* <!-- ใส่ class active ที่ menuCoupon และ menuProfile ได้ --> */}
                    <a href="/coupon-all" className={`menuCoupon ${coupon}`}><i></i><span>{t.profile.coupon}</span></a>
                    <a href="/customer-qr" className="menuQr hilight"><i></i><span>{t.profile.collection}</span></a>
                    <a href="/profile" className={`menuProfile ${profile}`}><i></i><span>{t.profile.profile}</span></a>
                </nav>
            </div>
        </section>
    )
}

export default BottomCustomer